import { useCompanyMutations } from "@app/entities/company/mutations";
import { useCompanyQueries } from "@app/entities/company/queries";
import { useCompany } from "@app/providers/CompanyContextProvider";
import { InputRef } from "antd";
import { useRef, useState } from "react";

export const useDetailsLoader = () => {
  const { selectedCompany, isCompaniesPending } = useCompany();
  const isOwner = !!selectedCompany?.isOwner;
  const { getCompanyData } = useCompanyQueries();
  const { fetchCompanyData, isCompanyDataFetching } = getCompanyData();
  const activationCodeReference = useRef<InputRef>(null);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const {
    refreshMemberActivationCode,
    deactivateAllMembers,
    emailDeactivatedMembers,
    isMutationPending,
  } = useCompanyMutations();

  const isLoading =
    isCompanyDataFetching || isMutationPending || isCompaniesPending;
  return {
    fetchCompanyData,
    refreshMemberActivationCode,
    deactivateAllMembers,
    emailDeactivatedMembers,
    activationCodeReference,
    isEmailModalOpen,
    setIsEmailModalOpen,
    isLoading,
    selectedCompany,
    isOwner,
  };
};
